import { Mail, Phone, MapPin } from "lucide-react";
import { SpeciaRing } from "@/components/SpeciaLogo";

export default function Footer() {
  return (
    <footer id="contact" className="border-t border-border bg-white/70">
      <div className="max-w-[1400px] mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <SpeciaRing size={30} />
            <span className="font-heading font-bold text-[#2A1E9E] text-xl lowercase">specia</span>
            <span className="h-5 w-px bg-border" />
            <span className="neon-word text-sm">TRINITY</span>
          </div>
          <p className="text-secondary max-w-md leading-relaxed">
            Autonomous AI testing agents that understand every SAP change, test what matters,
            and prove release readiness — for SAP SuccessFactors and SAP Public Cloud.
          </p>
          <p className="mt-5 font-semibold text-[#2A1E9E]">AI-Powered Testing. <span className="text-[#FF6B3D]">Human-Governed Assurance.</span></p>
        </div>
        <div>
          <p className="overline text-[#7C3AED] mb-4">Get in touch</p>
          <ul className="space-y-3 text-sm text-secondary">
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#FF6B3D]" /> testingagents@spectargroup.com</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#FF6B3D]" /> +61 3 9969 7928</li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-[#FF6B3D] mt-0.5" /> Level 2, Suite 2, 350 Collins Street, Melbourne VIC 3000</li>
          </ul>
        </div>
        <div>
          <p className="overline text-[#7C3AED] mb-4">Every engagement</p>
          <ul className="space-y-2 text-sm text-secondary">
            <li>Dedicated QA lead</li>
            <li>Weekly test reports</li>
            <li>Defect SLA: 24h triage</li>
            <li>Reusable automation assets</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-6 text-center text-xs text-secondary">
        © {new Date().getFullYear()} Specia — Trinity AI Testing Agents as a Service · trinity.platform.specia.ai
      </div>
    </footer>
  );
}
